import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

const PORTAL_TOKEN_KEY = 'xavior_portal_token';

interface ContactSessionValue {
  token: string | null;
  status: 'authed' | 'anon';
  setToken: (t: string) => void;
  clearSession: () => void;
}
const ContactSessionContext = createContext<ContactSessionValue | null>(null);

export function ContactSessionProvider({ children }: { children: ReactNode }) {
  const [token, setTokenState] = useState<string | null>(() => {
    try { return localStorage.getItem(PORTAL_TOKEN_KEY); } catch { return null; }
  });
  const setToken = useCallback((t: string) => { try { localStorage.setItem(PORTAL_TOKEN_KEY, t); } catch { /* storage unavailable */ } setTokenState(t); }, []);
  const clearSession = useCallback(() => { try { localStorage.removeItem(PORTAL_TOKEN_KEY); } catch { /* storage unavailable */ } setTokenState(null); }, []);
  const value: ContactSessionValue = { token, status: token ? 'authed' : 'anon', setToken, clearSession };
  return <ContactSessionContext.Provider value={value}>{children}</ContactSessionContext.Provider>;
}

export function useContactSession(): ContactSessionValue {
  const ctx = useContext(ContactSessionContext);
  if (!ctx) throw new Error('useContactSession must be used within a ContactSessionProvider');
  return ctx;
}
